export default "__VITE_PUBLIC_ASSET__546561bb__"